<template>
  <v-container>
    <v-row>
      <v-col cols="10" sm="6">
        <v-select
          v-model="select"
          :items="devices"
          item-text="setDeviceName"
          item-value="id"
          label="Select Device"
          @change="getData()"
          solo
          dense
          hide-details="auto"
        ></v-select>
      </v-col>
      <v-col cols="2" sm="6">
        <v-btn
          color="primary"
          :loading="pageLoading"
          :disabled="pageLoading"
          @click="getData()"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <div v-if="pageLoading">
      <v-row>
        <v-col>
          <h1 class="accent--text">Fetching Device...</h1>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12" class="pa-0">
          <DeviceCard :device="device" :chartData="chartData" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card color="primary">
            <div v-if="chartData.length === 0">
              <h1 class="white--text">No Chart Data</h1>
            </div>
            <ChartComponent v-else :chartData="chartData" />
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DeviceCard from "@/components/DeviceCard";
import ChartComponent from "@/components/ChartComponent";

export default {
  components: {
    DeviceCard,
    ChartComponent,
  },
  data() {
    return {
      model: null,
      select: null,
      pageLoading: false,
    };
  },
  computed: {
    ...mapState({
      btnLoading: (state) => state.btnLoading,
      dataLoading: (state) => state.dataLoading,
      user: (state) => state.auth.user,
      device: (state) => state.device.device,
      devices: (state) => state.device.devices,
      chartData: (state) => state.chart.chartData,
    }),
  },
  mounted() {
    this.getDevices();
    this.getInitialData();
  },
  methods: {
    async getInitialData() {
      try {
        if (!localStorage.getItem("selectedDevice")) {
          await (this.select = this.devices[0].id);
          this.getData();
        } else {
          this.select = localStorage.getItem("selectedDevice");
          this.getData();
        }
      } catch {
        console.log("error");
      }
    },

    async getData() {
      this.pageLoading = true;
      localStorage.setItem("selectedDevice", this.select);
      await this.$store.dispatch("fetchDevice", this.select);
      await this.$store.dispatch("fetchChartData", this.select);
      setTimeout(() => {
        this.pageLoading = false;
      }, 1000);
    },

    getDevices() {
      this.$store.dispatch("fetchAllDevices");
    },
  },
};
</script>
